import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Personal journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs gap-4">
          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            Experience
          </div>

          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  BSc in Information Systems
                </h3>
                <span className="qualification__subtitle">
                  Addis Ababa University
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2017 - 2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
              </div>
            </div>
          </div>
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------- */}
          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div className="-mx-2 py-1">
                <h3 className="qualification__title">Full Stack Developer</h3>
                <span className="qualification__subtitle">Seeb.ai</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Sep, 2024 - Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="-mx-2 py-1">
                <h3 className="qualification__title">
                  Frontend & Mobile App Developer
                </h3>
                <span className="qualification__subtitle">CutCRM</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Feb, 2025 - Apr, 2026
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div className="-mx-2 py-1">
                <h3 className="qualification__title">Full Stack Developer</h3>
                <span className="qualification__subtitle">Mereb</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Dec, 2023 - Oct, 2024
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="-mx-2 py-1">
                <h3 className="qualification__title">Frontend Developer</h3>
                <span className="qualification__subtitle">Eagle Tech</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Dec, 2023 - Feb, 2024
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div className="-mx-2 py-1">
                <h3 className="qualification__title">Software Engineer</h3>
                <span className="qualification__subtitle">Dan Energy</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Apr, 2022 - Mar, 2024
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
